export default __webpack_public_path__ + "static/media/tabletMode.a11de5e6.png";